module.exports = __webpack_public_path__ + "img/22.026da7df.jpg";